/* eslint-disable */
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols
// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.
import { Route as rootRouteImport } from './core/routes/__root';
import { Route as FflRouteImport } from './core/routes/ffl';
import { Route as IndexRouteImport } from './core/routes/index';
import { Route as FflDataRouteImport } from './core/routes/ffl.$data';
const FflRoute = FflRouteImport.update({
    id: '/ffl',
    path: '/ffl',
    getParentRoute: () => rootRouteImport,
});
const IndexRoute = IndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => rootRouteImport,
});
const FflDataRoute = FflDataRouteImport.update({
    id: '/$data',
    path: '/$data',
    getParentRoute: () => FflRoute,
});
const FflRouteChildren = {
    FflDataRoute: FflDataRoute,
};
const FflRouteWithChildren = FflRoute._addFileChildren(FflRouteChildren);
const rootRouteChildren = {
    IndexRoute: IndexRoute,
    FflRoute: FflRouteWithChildren,
};
export const routeTree = rootRouteImport
    ._addFileChildren(rootRouteChildren)
    ._addFileTypes();
